import {
  BacteriaResearch,
  BacteriaResearchSummary,
  ResearchFilter,
  Taxonomy,
} from '@snapi/types';
import { bacteriaName } from '@snapi/ui-utils';

import { Percentage } from '@snapi/luxury';
import { useMemo } from 'react';
import { ResearchFilterUtils } from '@snapi/utils';

const BacteriaResearchHeader = ({
  research: { name, taxonomy, category },
  percentage,
  protective,
  disruptive,
  neutral,
  total,
  expanded,
  onClick,
}: BacteriaResearch & {
  total: number;
  expanded: boolean;
  onClick: () => void;
}) => (
  <div className="flex flex-1 cursor-pointer" onClick={onClick}>
    <div className="flex flex-1 self-center">
      <span className="flex flex-1">
        <h5>
          {bacteriaName(name, taxonomy)}
          {taxonomy === Taxonomy.family && ' other'}
        </h5>
      </span>
      <span className="flex flex-1 justify-start item-center">
        <h5 className="ml-[54px]">
          <Percentage className="flex self-center" percentage={percentage} />
        </h5>
      </span>
    </div>
  </div>
);

export interface BacteriaResearchSummaryCardPdfProps
  extends BacteriaResearchSummary {
  filter: ResearchFilter;
  expanded: boolean;
  onExpand(): void;
}

export const BacteriaResearchSummaryCardPdf: React.FC<
  BacteriaResearchSummaryCardPdfProps
> = ({ filter, bacteria, species, expanded, onExpand }) => {
  const percentage = useMemo(() => {
    if (
      bacteria.research.taxonomy === Taxonomy.family &&
      ResearchFilterUtils.filterResearch(bacteria, filter)
    ) {
      return bacteria.other + bacteria.unclassified;
    }
    return ResearchFilterUtils.overlapPercentage(bacteria, species, filter);
  }, [species, filter, bacteria]);

  const other = useMemo(
    () =>
      ResearchFilterUtils.filterResearch(bacteria, filter)
        ? bacteria.other + bacteria.unclassified
        : 0,
    [filter, bacteria]
  );

  return (
    <div className="bg-white relative rounded-[10px] pt-1 pb-4 px-3">
      <BacteriaResearchHeader
        {...bacteria}
        total={bacteria.percentage}
        percentage={bacteria.percentage}
        expanded={expanded}
        onClick={onExpand}
      />
    </div>
  );
};
